import http from './cart/http.service';

export const buscadorService = {
    buscarNavBar,
    buscarProductoPorId,
    buscarProoductoPorIdAdmin,
    buscarProductoPorIdBackOffice,
    buscar,
    traerFiltros,
    traerVersiones
};


function buscarProductoPorId(id) {
    const url = '/public/producto/buscarProductoPorId';
    return http.post(url, JSON.stringify({id: id}));
}

function buscarProoductoPorIdAdmin(id) {
    const url = '/api/vendedor/producto/crear/upsert/data/' + id;
    return http.get(url);
}


/** Igual que la anterior pero por el carril de admin: trae la de cualquier vendedor. */
function buscarProductoPorIdBackOffice(id) {
    const url = '/api/admin/producto/crear/upsert/data/' + id;
    return http.get(url);
}

function buscarNavBar(data) {
    const url = '/public/general/buscarNavBar';
    return http.post(url, JSON.stringify(data));
}

function buscar(data) {
    const url = '/public/general/buscar';
    return http.post(url, JSON.stringify(data));
}

function traerFiltros() {
    const url = '/public/general/traerFiltros';
    return http.get(url);
}

// Las versiones no vienen en traerFiltros: son ~17.000 filas y el combo no sirve hasta que
// no hay un modelo elegido. Se piden por modelo, la primera vez que hace falta.
function traerVersiones(modeloId) {
    const url = `/public/general/versiones?modeloId=${modeloId}`;
    return http.get(url);
}


